import { render, staticRenderFns } from "./FilterCheckbox.vue?vue&type=template&id=5ec6629f&"
import script from "./FilterCheckbox.vue?vue&type=script&lang=ts&"
export * from "./FilterCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec6629f')) {
      api.createRecord('5ec6629f', component.options)
    } else {
      api.reload('5ec6629f', component.options)
    }
    module.hot.accept("./FilterCheckbox.vue?vue&type=template&id=5ec6629f&", function () {
      api.rerender('5ec6629f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/FilterCheckbox.vue"
export default component.exports